import React from 'react';
import { useApp } from '../context/AppContext';
import Icon from './Icon';
import './UtilityBar.css';

export default function UtilityBar() {
  const { navigate, openDrawer, user } = useApp();
  return (
    <div className="utibar">
      <div className="container utibar__inner">
        <div className="utibar__left">
          <span className="utibar__hotline">
            <Icon name="line" size={11} />
            客服 LINE 官方帳號 @qqcard
          </span>
          <span className="utibar__sep" aria-hidden>
            ·
          </span>
          <span className="utibar__deliver">
            <Icon name="mail" size={11} />
            hshamg690111@hotmail.com
          </span>
        </div>
        <nav className="utibar__right" aria-label="快速連結">
          <button
            type="button"
            className="utibar__link"
            onClick={() => navigate('info', { topic: 'guide' })}
          >
            儲值教學
          </button>
          <button
            type="button"
            className="utibar__link"
            onClick={() => (user ? openDrawer('account') : openDrawer('auth'))}
          >
            訂單查詢
          </button>
          <button
            type="button"
            className="utibar__link"
            onClick={() => openDrawer('chat')}
          >
            線上客服
          </button>
          <button
            type="button"
            className="utibar__link utibar__link--vip"
            onClick={() => navigate('vip')}
          >
            <Icon name="crown" size={11} />
            VIP 黑卡
          </button>
        </nav>
      </div>
    </div>
  );
}
